"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartWrapContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _selectors = require("../../redux/selectors");
var _ChartError = _interopRequireDefault(require("./ChartError"));
var _Header = _interopRequireDefault(require("./Header"));
var _Tabs = _interopRequireDefault(require("./Tabs"));
var _TabPanels = _interopRequireDefault(require("./TabPanels"));
var _ChartContent = _interopRequireDefault(require("./ChartContent"));
var _constants = require("../../utils/constants");
var _GroupFilter = _interopRequireDefault(require("./GroupFilter"));
var _widgets = require("../../widgets");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ChartWrapContent = exports.ChartWrapContent = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    chartId,
    isAlarm,
    equipmentKey,
    selectListFuncFromRedux,
    onClose
  } = _ref;
  const hasData = (0, _reactRedux.useSelector)(_selectors.selectHasData);
  const groupListLength = (0, _reactRedux.useSelector)(store => {
    const groupList = selectListFuncFromRedux(store) || {};
    return Object.keys(groupList).length;
  }, (prev, next) => prev === next);
  const activeGroup = (0, _reactRedux.useSelector)((0, _selectors.selectActiveGroup)(chartId), (prev, next) => prev === next);
  const isEmpty = hasData && (!groupListLength || !activeGroup);
  const borderTopLeftRadius = groupListLength > _constants.whenShowGroupSearch ? 0 : '10px';
  if (isEmpty && isAlarm) return /*#__PURE__*/_react.default.createElement(_widgets.IsEmptyChart, {
    onClose: onClose
  });
  if (isEmpty) return null; // hide chart if empty
  if (!hasData) return /*#__PURE__*/_react.default.createElement(_ChartError.default, {
    chartId: chartId,
    isAlarm: isAlarm
  });
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    sx: {
      boxShadow: _constants.styles.boxShadow.primary,
      borderRadius: isAlarm ? '0' : "10px ".concat(borderTopLeftRadius, " 10px 10px"),
      background: _constants.colors['main-color-cl-92'],
      padding: '16px 24px 32px',
      position: 'relative',
      overflow: 'visible'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, groupListLength > _constants.whenShowGroupSearch && /*#__PURE__*/_react.default.createElement(_GroupFilter.default, {
    chartId: chartId,
    equipmentKey: equipmentKey
  }), /*#__PURE__*/_react.default.createElement(_Header.default, {
    equipmentKey: equipmentKey
  }), /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    chartId: chartId,
    equipmentKey: equipmentKey
  }), /*#__PURE__*/_react.default.createElement(_TabPanels.default, {
    chartId: chartId,
    equipmentKey: equipmentKey
  }, /*#__PURE__*/_react.default.createElement(_ChartContent.default, {
    chartId: chartId,
    equipmentKey: equipmentKey,
    isAlarm: isAlarm
  }))));
}, function () {
  let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return prev.chartId === next.chartId && prev.isAlarm === next.isAlarm && prev.equipmentKey === next.equipmentKey && prev.selectListFuncFromRedux === next.selectListFuncFromRedux;
});
ChartWrapContent.propTypes = {
  chartId: _propTypes.default.string.isRequired,
  isAlarm: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  equipmentKey: _propTypes.default.oneOf(Object.values(_constants.keysForGroupChartsById)).isRequired,
  selectListFuncFromRedux: _propTypes.default.func.isRequired
};
ChartWrapContent.defaultTypes = {
  isAlarm: false
};